
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { myStudyMenu } from '@xt/client/dataSource/my-v2/index'
import HomeworkStudy from '../../components/HomeworkStudy.vue'
import RewardStudy from '../../components/RewardStudy.vue'
import DailyStudy from '../../components/DailyStudy.vue'
import CollectStudy from '../../components/CollectStudy.vue'

@Component({
  components: {
    HomeworkStudy,
    RewardStudy,
    DailyStudy,
    CollectStudy
  },
  asyncData(ctx) {
    const { active } = ctx.query
    const menu = myStudyMenu.find(item => item.value === active)

    if (!active || !menu)
      return {
        active: myStudyMenu[0].value,
        currentComponentName: myStudyMenu[0].component
      }

    const { value, component } = menu

    return {
      active: value,
      currentComponentName: component
    }
  }
})
export default class extends Vue {
  active: string
  currentComponentName: string

  get myStudyMenu() {
    return myStudyMenu
  }

  hanldeChangeMenu(key: string): void {
    if (this.active === key) return

    this.active = key

    this.currentComponentName = this.myStudyMenu.find(item => item.value === key)!.component

    this.$router.push({
      path: '/myv2/study',
      query: {
        active: key
      }
    })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
